
import { Component, Vue } from 'vue-property-decorator';
import { ITEMS_MENU } from '@/config/consts';

@Component({})
export default class Dashboard extends Vue {
  public items = ITEMS_MENU;
}
